import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectHasEditAiAdminDashboardPermission } from 'app/modules/session/selectors';
import { AIAgentConfiguration } from 'app/modules/aiAdmin/models';
import { AI_ADMIN_QUERY_KEYS } from 'app/modules/aiAdmin/queries/keys';
import { get } from 'app/shared/utils/fetchr';

export const useGetAiAgents = () => {
  const hasEditAiAdminDashboardPermissions = useSelector(
    selectHasEditAiAdminDashboardPermission,
  );

  return useQuery<AIAgentConfiguration[]>({
    enabled: hasEditAiAdminDashboardPermissions,
    queryFn: () => get<AIAgentConfiguration[]>(`/v1/ai-admin-dashboard/agents`),
    queryKey: AI_ADMIN_QUERY_KEYS.getAiAgents(),
  });
};
